import Vue from 'vue'
import { darkColors, lightColors } from '@/config/colors'

export const ClearLeftViewStateMixin = Vue.extend({
  methods: {
    clearLeftViewState: function (): void {
      this.$store.dispatch('postParams', null)
      this.$store.dispatch('commitLeftViewContent', '')
      this.$store.dispatch('toggleLeftViewState', false)
      this.$store.dispatch('commitAllowResend', false)
      // Reset left view background
      const root = document.querySelector(':root') as HTMLBodyElement
      root.style.setProperty('--app-default', this.$vuetify.theme.dark ? darkColors.appDefault : lightColors.appDefault)
    }
  }
})

export const ClearCardViewStateMixin = Vue.extend({
  methods: {
    clearCardState: function (): void {
      this.$store.dispatch('postParams', null)
      this.$store.dispatch('commitViewContent', '')
      this.$store.dispatch('toggleViewState', 'main')
      this.$store.dispatch('commitAllowResend', this.$store.getters.getRefreshLeftView)
      this.$store.dispatch('commitRefreshLeftView', false)
    }
  }
})
